import { Injectable } from '@angular/core';
import { getByKey as dbGetByKey, putByKey as dbPutByKey } from './entitlement-lookup-cache.db';

/**
 * Injectable wrapper around IndexedDB cache operations so they can be mocked in unit tests.
 */
@Injectable({ providedIn: 'root' })
export class EntitlementLookupCacheDbService {
  getByKey<T>(key: string): Promise<T | null> {
    return dbGetByKey<T>(key);
  }

  putByKey<T extends { email: string }>(key: string, value: T): Promise<void> {
    return dbPutByKey(key, value);
  }
}
